import { createFileRoute } from "@tanstack/react-router"
import DesignSystemInlineAlert from "~/pages/design-system/components/InlineAlert"

export const Route = createFileRoute("/_auth/internal/design-system/components/inline-alert")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemInlineAlert />
}
